import React, { useEffect, useState } from "react";
import {HISTORY_ICON,CALENDER_ICON } from "assets/constants/Icons";
import MaterialTable from "material-table";
import { ThemeProvider } from '@mui/styles';
import { createTheme } from '@mui/material';
import { getHistoryList, getUserHistoryList } from "lib/axiosUtils";
import "./user-style.css";
import moment from 'moment';
import { SUPER_ADMIN } from 'assets/constants/Constants';
import Spinner from 'components/Spinner';

const HistoryPage = () => {
  const [logList, setLogList] = useState([]);
  const userRole = JSON.parse(localStorage.getItem("userRole"));
  const userDetail = JSON.parse(localStorage.getItem("userData"));
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        fetchLogList();
         // eslint-disable-next-line
    },[]);

    const fetchLogList = async () => {
        setIsLoading(true);
        const dateParms = {
            userFromDate :fromDate,
            userToDate : toDate,
        }
        let data;
        try {
            if (userRole.user_role === SUPER_ADMIN) {
                data = await getHistoryList({}, dateParms);
            }else{
                data = await getUserHistoryList({}, dateParms,userDetail._id);
            }
            setLogList(data.data.result);
            setIsLoading(false);
        }
        catch (error) {
            setIsLoading(false);
            console.log("error while fetching data", error);
        }
    }

    const searchList = () => {
        if (!fromDate) {
            alert("Please select from date");
            return;
        }

        if (!toDate) {
            alert("Please select to date");
            return;
        }
        fetchLogList();
    }

    const mytheme= createTheme({});
    return (<>
    {
        isLoading === true ? (
            <Spinner />
        ) : 
        (
        <div className="main-content">
          <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
            <div className="col-md-10 sm_device"><i className={`${HISTORY_ICON}`}></i> HistoryPage</div>
            <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={`${CALENDER_ICON}`}></i> {moment().format("DD MMM YYYY")}</div>
          </div>
          <div style={{ borderBottom: '1px solid lightgray', marginBottom: 15, marginTop: 15 }} />
          <div className="list-wrapper">
            <div className="referral-wrapper">
                <label className="ml-5">From Date: </label>
                <div className="date-picker-box">
                    <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} />
                </div>

                <label className="ml-5">To Date:</label>
                <div className="date-picker-box">
                    <input type="date" value={toDate} min={fromDate} onChange={(e) => setToDate(e.target.value)} />
                </div>
                <button className="brand-button ml-5"  onClick={searchList}>Search</button>
            </div>

            <div className="mt-4 border list-table-div site-table" style={{ marginBottom: 50 }}>
            {
                logList && logList.length > 0 ? (
                        <ThemeProvider theme={mytheme}>
                          <MaterialTable
                              columns={[
                                  {
                                      title: "Date", field: "date",
                                      cellStyle: { cellWidth: '12%', color: '#808080', fontSize: 14, textTransform: 'none' }
                                  },
                                  {
                                    title: "User", field: "user",
                                    cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                  },
                                  {
                                      title: "Module Name", field: "module_name",
                                      cellStyle: { cellWidth: '18%', fontWeight: 'bolder', color: '#000000', fontSize: 14 }
                                  },
                                  {
                                      title: "Details", field: "details",
                                      cellStyle: { cellWidth: '20%', color: '#808080', fontSize: 14, textTransform: 'none' },
                                      sorting: false
                                  },
                                                                       
                              ].filter(Boolean)}
                              data={
                                logList.map((item) => {
                                    return (
                                        {
                                            date: new Date(item.created_date_time).toLocaleDateString('en-IN', {
                                                day: '2-digit',
                                                month: '2-digit',
                                                year: 'numeric',
                                                hour: '2-digit',
                                                minute: '2-digit',
                                                second: '2-digit',
                                                hour12: false 
                                            }),
                                            user: item.full_name,
                                            module_name: item.module_name,
                                            details: item.log_text,                                         
                                        }
                                    )
                                })
                            }

                              options={{
                                  actionsColumnIndex: -1,
                                  headerStyle: {
                                      color: '#999998',
                                      fontWeight: 'bolder',
                                      fontSize: 15
                                  },
                                  filtering: true,
                                  sorting: true,
                                  columnsButton: true,
                                  exportButton: true,
                                  exportFileName: "History Page Data"
                              }}
                             />
                        </ThemeProvider>
                    ) : (
                      <div className="text-center pt-2">
                          <label>Data is not present</label>
                      </div>
                    )
            }
          </div>
          </div>
        </div>
      )
    }
  </>);
}

export default HistoryPage;